import { createApp } from 'vue'
import __t from "../../../../../helpers/translate";
import vue_helpers from "../../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import fmtDate from "../../../../../helpers/fmtDay";

import contragent_files from "./contragent_files.vue";

window.P_FILES = createApp({
    name : "P_FILES",
    id : "P_FILES",
    components : {
        contragent_files : contragent_files,
    }
})
    .mixin(fmtDate)
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

P_FILES.mount('#contragent_files');